import { Document, Page } from '@react-pdf/renderer';


import SrScalePage1 from './srScalepage1';
import SrScalePage2 from './srScalePage2';
import SrVikalp from './srVikalp';
import SrVachanPatra from './srVachanPatra';
import SrPraPatra2 from './srPraPatra2';
import SrPraPatra3 from './srPraPatra3';

const SrScalePurePDF = ({ result }) => (
  
    <Document>
  
      <Page size="A4">
        <SrScalePage1 result={result}/>
      </Page>
      <Page size="A4">
        <SrScalePage2 result={result}/>
      </Page>
  
    <Page size="A4">
      <SrVikalp result={result}/>
    </Page>

    <Page size="A4">
      <SrVachanPatra result={result}/>
    </Page>
    
    <Page size="A4" orientation='landscape'>
      <SrPraPatra2 result={result}/>
    </Page>

    <Page size="A4" orientation='landscape'>
      <SrPraPatra3 result={result}/>
    </Page>
    </Document>
  );

export default SrScalePurePDF;
